import POSITIONS from "@Constants/positions";

const getSpiffDepartment = (position: string) => {
	switch (position) {
		case POSITIONS.SERVICE.SERVICE_TECHNICIAN:
		case POSITIONS.BODY_SHOP.BODY_SHOP_TECHNICIAN:
		case POSITIONS.BODY_SHOP.BODY_SHOP_PAINTER:
			return "Service";
		default:
			return "Sales";
	}
};

export { getSpiffDepartment };
